import { useEffect } from 'react';
import { setBlurActive } from 'store/features/meeting/slice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { selectMeetingMode } from 'store/features/meeting/selector';

const useMeetingBlurListener = () => {
  const dispatch = useAppDispatch();
  const meetingMode = useAppSelector(selectMeetingMode);

  useEffect(() => {
    if (!meetingMode) return;

    const handleBlur = () => {
      dispatch(setBlurActive(true)); // Blur ON when exiting the tab
    };

    const handleFocus = () => {
      // Blur should not be closed automatically; the user will close it manually.
    };

    window.addEventListener('blur', handleBlur);
    window.addEventListener('focus', handleFocus);

    return () => {
      window.removeEventListener('blur', handleBlur);
      window.removeEventListener('focus', handleFocus);
    };
  }, [meetingMode, dispatch]);
};

export default useMeetingBlurListener;
